import AppLayout, { AppLayoutProps } from "@amzn/awsui-components-react/polaris/app-layout";

import useAppDrawers from "../../components/ChatbotWidget/useAppDrawers";

const AdminAppLayout = (props: AppLayoutProps) => {
    const drawerProps = useAppDrawers();

    return <AppLayout {...props} {...drawerProps} />;
};

export default AdminAppLayout;
